import type { TranslationKey } from "@shared/i18n/translationKey";

// Constantes de dominio del módulo license-application.

// Tipos de solicitud (valores del picklist del CRM, tal cual los espera el backend).
export const LEAVE_TYPE = {
  RELAX_DAY: "Relax Day",
  BIRTHDAY: "Birthday",
  FAMILY_DAY: "Family Day",
  PERSONAL_DAY: "Personal Day",
  UNPAID_LEAVE: "Permiso NO Remunerado",
  SICKNESS_CERTIFICATE: "Constancia Enfermedad",
  OTHER: "Otro",
};

// Tipos que consumen días de la disponibilidad general del colaborador.
export const TYPES_FROM_AVAILABILITY = [
  LEAVE_TYPE.RELAX_DAY,
  LEAVE_TYPE.BIRTHDAY,
  LEAVE_TYPE.FAMILY_DAY,
  LEAVE_TYPE.PERSONAL_DAY,
];

// Tipos de permiso no remunerado (validan contra el tope de días sin goce).
export const TYPES_UNPAID = [LEAVE_TYPE.UNPAID_LEAVE];

// Estados del workflow de aprobación de la solicitud (labels del CRM, en español).
export const REQUEST_STATUS = {
  PENDING: "Pendiente",
  APPROVED_SUPERVISOR: "Aprobado Supervisor",
  APPROVED_MANAGEMENT: "Aprobado Gerencia",
  REJECTED: "Rechazado",
  REVERSE: "Reversar",
  CANCEL: "Cancelar",
};

// Estados que cuentan como "solicitud activa" al chequear duplicados del año en curso.
export const ACTIVE_STATUSES = [
  REQUEST_STATUS.PENDING,
  REQUEST_STATUS.APPROVED_MANAGEMENT,
  REQUEST_STATUS.APPROVED_SUPERVISOR,
];

// Tope de días por categoría (regla de negocio del front, candidata a moverse al backend).
export const DAYS_ALLOWED = { PAID: 1, NOT_PAID: 10 };

// Reglas del archivo adjunto (evidencia de la solicitud).
export const ALLOWED_FILE_EXTENSIONS = ["pdf", "docx", "xlsx", "jpg", "png", "jpeg"];
export const MAX_FILE_SIZE_BYTES = 3_000_000;

// Estado inicial de los días disponibles (antes duplicado en ambas páginas).
export const DEFAULT_VACATION_DAYS = {
  daysAvailability: 0,
  daysAvailabilityPaid: 0,
  daysAvailabilityPending: 0,
  daysSicknessRecord: 0,
};

// Meta de presentación por estado: clave i18n + color del Chip (los estados sin
// color usan el Chip por defecto de MUI).
export const STATUS_CHIP_META = {
  [REQUEST_STATUS.PENDING]: { labelKey: "pending" },
  [REQUEST_STATUS.REJECTED]: { labelKey: "rejected", color: "#d41010" },
  [REQUEST_STATUS.APPROVED_SUPERVISOR]: { labelKey: "preApproved", color: "#05a724" },
  [REQUEST_STATUS.APPROVED_MANAGEMENT]: { labelKey: "approvedManagement", color: "#056918" },
  [REQUEST_STATUS.REVERSE]: { labelKey: "reverse", color: "#fa7602" },
  [REQUEST_STATUS.CANCEL]: { labelKey: "cancelled" },
} satisfies Record<string, { labelKey: TranslationKey; color?: string }>;
